export const boardTeaserVideoURL = "https://player.vimeo.com/video/337280106";
